module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step1@2x.be1099ad.png";